import React from 'react';
import './Team.css';

function Team() {
  const teamIntro = [
    { title: '생성형 AI영상', description: 'AI 워크플로우로 숏폼·브랜드 필름·CF까지 빠르게 제작하는 생성형 영상 스튜디오' },
    { title: '혁신적인 AI솔루션 개발', description: '기업 맞춤 AI 영상 제작 파이프라인·작업공간·플랫폼을 설계하고 구축하는 솔루션 개발' },
    { title: '가정용AI로봇솔루션', description: '가정용 로봇 플랫폼과 AI 서비스를 연결하는 로보틱스·IoT 솔루션' },
  ];

  const teamMembers = [
    { name: '박수형', role: '팀리더, 기획, AI영상제작, 백엔드/프론트엔드 담당', description: 'AI 기반 서비스의 전체 아키텍처를 설계, 사용자 경험부터 백엔드 시스템 통합\nAI 학습 모델, 데이터베이스, 사용자 인터페이스 등 효율적인 상호작용 설계.\nAI영상 활용 실사/애니메이션 광고, 숏폼, 시리즈 및 영화 제작', image: 'd-0.png' },
    {
      name: '박형동',
      role: '비주얼 개발 및 애니메이션 협업',
      description: '現 연성대학교 웹툰만화콘텐츠과 교수\n한국만화애니메이션학회 이사\n한국저작권위원회 심의위원\n前 부천만화대상 심사위원장\n前 청강문화산업대학교 웹툰만화콘텐츠스쿨 교수\n前 서울교대, 한양여대, 남서울대, 경기대, 성공회대 강의',
      image: 'd-2.png',
      isCollaborator: true,
    },
    { name: '최원일', role: '기획 / 서비스 운영', description: '기획 및 운영으로 서비스 설계 및 홍보, 운영 담당.\n베타 테스트를 기획하고 실행하며, 사용자 피드백을 수집하여 서비스 개선에 반영\n서비스 운영 전략을 수립하고, 지속적인 모니터링 및 서비스 개선 작업을 수행', image: 'd-1.png' },
    { name: '이선정', role: 'AI 서비스 기획 및 AI 영상 생성', description: 'AI 영어학습 서비스 기획 및 테스트, AI 숏폼 및 영상 제작을 위한 제안, 마케팅 및 온라인 서비스 설계', image: null },
    { name: '박수현', role: '자문 / 보안 및 기술 자문', description: '네트워크 보안 전문가로 국내 모보안기업 수석연구원 및 다수 IT벤처 자문.\n사용자 데이터 암호화, 안전한 데이터 전송 프로토콜 구현, 접근 제어 시스템 등 자문\n언어학습 서비스의 개인정보 보호 정책 및 보안 취약점 분석 등 자문', image: null, isAdvisor: true },
  ];

  return (
    <div className="team-page team-page--studio">
      <section className="team-page-hero">
        <div className="team-page-hero__inner">
          <p className="team-page-hero__label">STAR612 STUDIO</p>
          <h1>Our Team</h1>
          <p>AI 영상·솔루션·개발을 만드는 작은별612 팀을 소개합니다.</p>
        </div>
      </section>
      <div className="team-container">
        <h2 className="team-intro">
          <span className="highlight">작은별612</span> 팀은
        </h2>
        <div className="team-separator"></div>
        <p className="team-description">
          AI 영상 제작·솔루션 구축·플랫폼 개발 역량을 갖춘 팀으로, 생성형 AI영상부터 기업 맞춤 제작 시스템, 가정용 AI 로봇 솔루션까지 통합 서비스를 제공합니다.
        </p>

        <div className="team-intro-boxes">
          {teamIntro.map((item, index) => (
            <React.Fragment key={index}>
              <div className="team-intro-box">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              {index < teamIntro.length - 1 && <div className="plus-sign">+</div>}
            </React.Fragment>
          ))}
        </div>

        <div className="team-members">
          {teamMembers.map((member, index) => (
            <div key={index} className={`team-member ${member.isAdvisor ? 'team-member--advisor' : ''} ${member.isCollaborator ? 'team-member--collaborator' : ''}`}>
              {member.image && (
                <img src={process.env.PUBLIC_URL + `/images/${member.image}`} alt={member.name} className="member-image" />
              )}
              <div className="member-info">
                <h3 className={member.isAdvisor ? 'advisor-name' : ''}>{member.name}</h3>
                <h4>{member.role}</h4>
                <p>{member.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Team;
